import React from 'react';
import { trackViewedPage } from '../../../../utilities';
import type { NavigationTab } from '../../../../contracts';
import {
  NavigationItemLink,
  NavigationItemContainer,
  NavigationLabel,
  NavigationDescription,
  NavigationLabelContainer,
  PersonalDetailsIcon,
  FinancingTermsIcon,
  NotificationBellIcon,
  ReferralsIcon,
  RightArrowIcon,
  PrivacySettings
} from './MobileNavBar.styles';
import { NOTIFICATION_SETTINGS_PATH } from '../../../../tabs/NotificationSettings/routes/routePaths';
import { FINANCING_TERMS_PATH } from '../../../../tabs/FinancingTerms/routes/routePaths';
import { PERSONAL_DETAILS_PATH } from '../../../../tabs/PersonalDetails/routes/routePaths';
import { PRIVACY_SETTINGS_ROUTE } from '../../../../tabs/PrivacySettings/PrivacySettings';
import { REFERRALS_PATH } from '../../../../tabs/Referrals/routes/routePaths';

const icons: Record<string, React.ComponentType> = {
  [NOTIFICATION_SETTINGS_PATH]: NotificationBellIcon,
  [FINANCING_TERMS_PATH]: FinancingTermsIcon,
  [PERSONAL_DETAILS_PATH]: PersonalDetailsIcon,
  [PRIVACY_SETTINGS_ROUTE]: PrivacySettings,
  [REFERRALS_PATH]: ReferralsIcon
};

type OwnProps = {
  tab: NavigationTab;
};

function MobileNavigationItem({ tab }: OwnProps) {
  const NavigationIcon = icons[tab.path];

  return (
    <NavigationItemLink to={tab.path} key={tab.path} onClick={() => trackViewedPage(tab.path)}>
      <NavigationItemContainer>
        <NavigationIcon />
        <NavigationLabelContainer>
          <NavigationLabel>{tab.displayName}</NavigationLabel>
          <NavigationDescription>{tab.description}</NavigationDescription>
        </NavigationLabelContainer>
        <RightArrowIcon />
      </NavigationItemContainer>
    </NavigationItemLink>
  );
}

export default MobileNavigationItem;
